import { Component, inject, signal } from '@angular/core';
import {
  IonBackButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonText,
  IonTitle,
  IonToggle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { PwaInstallButtonComponent } from '@libs/core/lib/pwa/pwa-install-button.component';
import { PWAInstallStore } from '@libs/core/lib/pwa/pwa-install.store';
import { NotificationsStore } from '@libs/mtjr/shared/notifications/notifications.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mav-settings',
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonBackButton,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonIcon,
    IonToggle,
    TranslatePipe,
    IonCard,
    PwaInstallButtonComponent,
    IonText,
  ],
  template: `
    <ion-header [translucent]="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button defaultHref="/main"></ion-back-button>
        </ion-buttons>
        <ion-title>{{ 'SETTINGS.TITLE' | translate }}</ion-title>
        @if (pwaInstallStore.isInstallable()) {
          <ion-buttons slot="end" class="md:me-3">
            <mtjr-pwa-install-button />
          </ion-buttons>
        }
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <div class="flex">
        <ion-list class="max-w-[650px] w-full">
          <ion-card>
            <ion-item>
              <ion-icon name="notifications-outline" slot="start"></ion-icon>
              <ion-label>
                <h2>{{ 'SETTINGS.NOTIFICATIONS' | translate }}</h2>
                <p>{{ 'SETTINGS.NOTIFICATIONS_DESCRIPTION' | translate }}</p>
              </ion-label>
              <ion-toggle slot="end" [checked]="isNotificationsOn()" (click)="toggleNotifications($event)"></ion-toggle>
            </ion-item>
            @if (!notificationsStore.isNotificationSupported()) {
              <div class="mt-2 rounded-lg bg-warning/5 px-3 py-2 w-auto mx-4 mb-4">
                <ion-text color="warning">
                  {{ 'NOTIFICATIONS.NOTIFICATIONS_NOT_SUPPORTED' | translate }}
                </ion-text>
              </div>
            }
          </ion-card>
        </ion-list>
      </div>
    </ion-content>
  `,
})
export class SettingsPage {
  notificationsStore = inject(NotificationsStore);
  isNotificationsOn = signal(this.notificationsStore.isGranted());
  pwaInstallStore = inject(PWAInstallStore);

  async toggleNotifications(event: Event) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();
    if (!this.isNotificationsOn()) {
      await this.notificationsStore.requestPermission({ showAlert: false });
      setTimeout(() => {
        this.isNotificationsOn.set(this.notificationsStore.isGranted());
      });
    } else {
      const didRemove = await this.notificationsStore.removeFcmToken();
      setTimeout(() => {
        this.isNotificationsOn.set(!didRemove);
      });
    }
  }
}
